import { render, staticRenderFns } from "./TaskProperties.vue?vue&type=template&id=b59d0998&scoped=true"
import script from "./TaskProperties.vue?vue&type=script&lang=js"
export * from "./TaskProperties.vue?vue&type=script&lang=js"
import style0 from "./TaskProperties.vue?vue&type=style&index=0&id=b59d0998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59d0998",
  null
  
)

export default component.exports